import React from "react";
import Reveal from "./Reveal";
import SectionHeading from "./SectionHeading";
import { experience } from "../data/resume";

const Experience = () => (
    <section id="experience" aria-labelledby="experience-title" className="py-10 md:py-14">
        <SectionHeading id="experience-title" index="01" label="Career" title="Professional" accent="Experience" />

        <ol className="mt-8 md:mt-10">
            {experience.map((job, index) => (
                <Reveal as="li" key={job.company} delay={index * 60}>
                    <article className="group relative grid gap-x-8 gap-y-3 border-t border-fg/10 py-6 md:grid-cols-[10.5rem_minmax(0,1fr)]">
                        <span
                            aria-hidden="true"
                            className="absolute -top-px left-0 h-px w-full origin-left scale-x-0 bg-accent transition-transform duration-700 ease-out-expo group-hover:scale-x-100"
                        />
                        <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1 md:block">
                            <p className="font-mono text-[12px] tabular-nums tracking-[0.02em] text-fg">{job.period}</p>
                            {job.location && <p className="label text-subtle md:mt-2.5">{job.location}</p>}
                        </div>
                        <div>
                            <h3 className="text-[clamp(1.6rem,2.4vw,2rem)] font-extrabold leading-none tracking-[-0.01em] transition-colors duration-300 stretch-condensed group-hover:text-accent-text">
                                {job.company}
                            </h3>
                            <p className="mt-2 font-medium text-accent-text">{job.role}</p>
                            {job.points.length > 1 ? (
                                <ul className="mt-4 space-y-2">
                                    {job.points.map((point) => (
                                        <li key={point} className="flex gap-3 leading-relaxed text-muted">
                                            <span aria-hidden="true" className="shrink-0 text-accent-text">–</span>
                                            <span>{point}</span>
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <p className="mt-4 leading-relaxed text-muted">{job.points[0]}</p>
                            )}
                        </div>
                    </article>
                </Reveal>
            ))}
        </ol>
    </section>
);

export default Experience;
